export default "__VITE_ASSET__NqekvdWq__"